import { render, staticRenderFns } from "./WiseTransferLink.vue?vue&type=template&id=0efa0eb7&scoped=true&"
import script from "./WiseTransferLink.vue?vue&type=script&lang=js&"
export * from "./WiseTransferLink.vue?vue&type=script&lang=js&"
import style0 from "./WiseTransferLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WiseTransferLink.vue?vue&type=style&index=1&id=0efa0eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa0eb7",
  null
  
)

export default component.exports